import PropTypes from 'prop-types';
import {Navigate, Route, Routes} from 'react-router-dom';

import ApkLoginPage from './ApkLoginPage';
import ApkListPage from './ApkListPage';
import {isApkAuthenticated} from './apkAuth';

const Protected = ({children}) => {
  if (!isApkAuthenticated()) {
    return <Navigate to='/apk-distribution/login' replace />;
  }
  return children;
};

Protected.propTypes = {
  children: PropTypes.node.isRequired,
};

const ApkDistributionApp = () => {
  return (
    <Routes>
      <Route path='login' element={<ApkLoginPage />} />
      <Route
        index
        element={
          <Protected>
            <ApkListPage />
          </Protected>
        }
      />
      <Route
        path='*'
        element={<Navigate to='/apk-distribution' replace />}
      />
    </Routes>
  );
};

export default ApkDistributionApp;
